import { createPortal } from 'react-dom';
import { Box } from '@mui/material';
import { useWatch } from 'react-hook-form';

import { useDisclosure } from '@hooks/useDisclosure';
import { RemarkButton } from '@Components/IconButton';
import Remark from '@Components/Remark';
import { useGreenhouseForm } from '../../EsgGreenhouseFormProvider';
import {
  IGreenhouseGoalTermFormValues,
  ICarbonFormValues,
} from '../../EsgGreenhouseFormProvider/types';

export const CARBON_REMARK_ID = 'carbon-remark';

const CarbonNeutralityRemark = () => {
  const { control, getValues } = useGreenhouseForm();

  const { remark } =
    getValues('greenhouseGoalTerm.carbon') ?? ({} as ICarbonFormValues);
  const [isRemarkOpen, { open, close }] = useDisclosure(!!remark);

  const remarkEl = document.getElementById(CARBON_REMARK_ID);

  const { completedSection } =
    useWatch({ name: 'greenhouseGoalTerm', control }) ??
    ({} as IGreenhouseGoalTermFormValues);

  const { isCompletedTh, isCompletedEn } = completedSection ?? {};

  return (
    <>
      <RemarkButton onClick={open} disabled={isCompletedTh && isCompletedEn} />
      {isRemarkOpen &&
        remarkEl &&
        createPortal(
          <Box mt={2}>
            <Remark
              topic="การตั้งเป้าหมายความเป็นกลางทางคาร์บอน (Carbon Neutrality)​"
              fieldPath="greenhouseGoalTerm.carbon.remark"
              setOpen={open}
              onDelete={close}
              isCompletedTh={isCompletedTh}
              isCompletedEn={isCompletedEn}
            />
          </Box>,
          remarkEl
        )}
    </>
  );
};

export default CarbonNeutralityRemark;
